import React, { useState, useRef } from "react";

import { PrimaryButton } from "widgets";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import Loader from "shared/Icons/Loader/Loader";

import styles from "./FileUpload.module.scss";

const handleFileChange = (event, setSelectedFile) => {
  setSelectedFile(event.target.files[0]);
};

const handleUpload = ( selectedFile, onUpload, openSnackbar,setSelectedFile) => {
  onUpload(selectedFile,{
      onSuccess: (data) => {
        openSnackbar("File uploaded successfully!", "success");
        setSelectedFile(null);
        window.location.reload();
      },
      onError: (err) => {
        openSnackbar(err.message || "Upload failed", "error");
      }
    }
  );   
};

const FileUpload = (props) => {
  const { uploadLabel,onUpload,isLoading } = props;
  const { openSnackbar } = useSnackbarContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.dashedBox}>
        <p>{selectedFile ? selectedFile.name : "Upload your file here."}</p>
        <input
          type="file"
          onChange={(event) => handleFileChange(event, setSelectedFile)}
          ref={fileInputRef}
          className={styles.fileInput}
        />
      </div>
      <PrimaryButton
        disabled={!selectedFile}
        onClick={() =>
          handleUpload(
            selectedFile,
            onUpload,
            openSnackbar,
            setSelectedFile,
            fileInputRef,
            setSelectedFile
          )
        }
      >
        {isLoading ? <Loader /> : uploadLabel}
      </PrimaryButton>
    </div>
  );
};

export default FileUpload;
